/** @jsx jsx */
import { useMemo } from 'react';
import { jsx } from '@emotion/core';
import { N80, N900 } from '@atlaskit/theme/colors';
import { fontFamily as getFontFamily } from '@atlaskit/theme/constants';
const fontFamily = getFontFamily();
export const labelCSS = () => ({
  fontFamily: fontFamily,
  alignItems: 'center',
  display: 'flex',
  color: `var(--ds-text-highEmphasis, ${N900})`,
  cursor: 'default',
  '&[data-disabled]': {
    color: `var(--ds-text-disabled, ${N80})`,
    cursor: 'not-allowed'
  }
});
export default function Label({
  children,
  isDisabled,
  testId,
  onClick
}) {
  const styles = useMemo(() => labelCSS(), []);
  return jsx("label", {
    css: styles,
    "data-testid": testId,
    "data-disabled": isDisabled || undefined,
    onClick: onClick
  }, children);
}